<template>
  <DataListStateful
    title="Категории товаров"
    resource="product-categories"
    store="productCategories"
    :columns="columns"
    :filter-options="filter"
  />
</template>

<script>
export default {
  data() {
    return {
      columns: [
        { title: "Ид", name: "id", sortable: false },
        { title: "Наименование", name: "title", sortable: true },
        { title: "Тип", name: "type", dataPath: "Type.Title", sortable: true },
        {
          title: "Объемный тарифные вес, кг/м3",
          name: "volumeRateWeigth",
          sortable: true,
        },
        { title: "Тариф - Италия, $", name: "rateItaly", sortable: true },
        { title: "Тариф - Германия, $", name: "rateGermany", sortable: true },
        { title: "Тариф - США, $", name: "rateUSA", sortable: true },
      ],
      filter: {
        title: {
          title: "Наименование",
          type: "text",
        },
        type: {
          title: "Тип",
          type: "enum",
          resource: "product-category-types",
        },
        volumeRateWeigth: {
          title: "Объемный тарифные вес, кг/м3",
          type: "decimal",
        },
        rateItaly: {
          title: "Тариф - Италия, $",
          type: "decimal",
        },
        rateGermany: {
          title: "Тариф - Германия, $",
          type: "decimal",
        },
        rateUSA: {
          title: "Тариф - США, $",
          type: "decimal",
        },
      },
    };
  },
};
</script>
